module.exports = __webpack_public_path__ + "img/icon-tele-gray.adf7e873.svg";